<mat-card class="card">

    <div>

        <h2 style="text-align: center;">{{'FP_T1' | translate}}</h2>
        <div  *ngIf="step === 1">
            <p> {{'REG_P3' | translate}} </p>
            <form [formGroup]="forgotForm" style="margin-bottom: 1rem;">
                <p class="label" [ngClass]="{'label-err': emailErr}">Email</p>
                <input placeholder="Email" formControlName='email' [ngClass]="{'error': emailErr}" (focus)="clearErr()"
                (focusout)="focusOutCheck()">
                <p *ngIf="emailErr" class="error-text">{{emailErr}}</p>
            </form>

            <div style="display: flex; justify-content:center;">
                <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>
                <button *ngIf="!loading" mat-raised-button class="consentButton" (click)="resetPassword()">
                    {{'LOG_ON_B1' | translate}}
                </button>
            </div>
        </div>

        <div *ngIf="step === 2">
            <p>
                {{'FP_P1' | translate}}<br><br> {{forgotForm.controls.email.value}}. <br><br>
                {{'FP_P2' | translate}}
            </p>
        </div>
    </div>



</mat-card>